import { render, staticRenderFns } from "./TransactionResult.vue?vue&type=template&id=4c90822d&scoped=true&"
import script from "./TransactionResult.vue?vue&type=script&lang=ts&"
export * from "./TransactionResult.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionResult.vue?vue&type=style&index=0&id=4c90822d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c90822d",
  null
  
)

export default component.exports